import myNetwork from '@/mycore/network/apimanagement';
import * as cms from '../../../mycore/module/cms';

export function getCameraDetail(callback, service_code) {
    myNetwork
        .post('/api/cms/camera', { service_code })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function getLandingBanner(callback, service_code) {
    cms.getLandingBanner(callback, service_code);
}
